import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SettingApiData } from "../../services/CommonService";

interface Setting {
  key_name: string;
  key_value: any;
}

interface SettingsState {
  isLoading: boolean;
  error: any;
  settingsData: {};
}

const initialState: SettingsState = {
  isLoading: false,
  error: null,
  settingsData: {},
}
export const fetchSettingsDetails: any = createAsyncThunk(
  "/settings-data",
  async () => {
    const response = await SettingApiData();
    return response.data;
  }
);
const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettingsData(state, action: PayloadAction<Setting[]>) {
      state.settingsData = action.payload;
    },
    // updateSetting(state, action: PayloadAction<{ keyName: string; newValue: any }>) {
    //   const { keyName, newValue } = action.payload;
    //   const settingToUpdate = state.settingsData.find(setting => setting.key_name === keyName);
    //   if (settingToUpdate) {
    //     settingToUpdate.key_value = newValue;
    //   }
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettingsDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSettingsDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        let data = action?.payload?.reduce(
          (acc: any, { key_name, key_value }: any) => {
            acc[key_name] = key_value;
            return acc;
          },
          {}
        );

        state.settingsData = data;
      })
      .addCase(fetchSettingsDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.error.message || "Failed to fetch settings details";
        console.error("Fetch settings details failed:", action.error);
      });
  },
});

export const { setSettingsData } = settingsSlice.actions;

export default settingsSlice.reducer;
